export var panelVariants = {
    visible: {
        transition: {
            staggerChildren: 0.05,
            delayChildren: 0.07,
        },
    },
    hidden: {
        transition: {
            staggerChildren: 0.05,
            when: "afterChildren",
        },
    },
};
export var panelItemVariants = {
    entry: {
        x: 0,
    },
    visible: {
        x: 0,
        transition: { ease: [0, 0.2, 0.4, 1], duration: 0.3 },
    },
    hidden: {
        x: "-100%",
        transition: { ease: [0, 0.2, 0.4, 1], duration: 0.3 },
        transitionEnd: {
            opacity: 1,
        },
    },
};
export var containerVariants = {
    in: {
        transition: {
            staggerChildren: 0.05,
            delayChildren: 0.07,
        },
    },
    out: {
        transition: {
            staggerChildren: 0.05,
            when: "afterChildren",
        },
    },
};
export var itemVariants = {
    in: {
        x: "0",
        transition: { ease: [0, 0.2, 0.4, 1], duration: 0.3 },
    },
    out: {
        x: "100%",
        transition: { ease: [0, 0.2, 0.4, 1], duration: 0.3 },
    },
};
